// Flyora Weddings — content constants

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/y6kk7j6b_b29d4b48-c7c0-4eca-8a23-5ee7538a6aa5%20%281%29.webp";

export const WHATSAPP_NUMBER = "919747117777";
export const WHATSAPP_MESSAGE =
  "Hi Flyora — I'm interested in booking a wedding film. Could you share availability, sample films and pricing?";

export const NAV_LINKS = [
  { label: "Films", href: "#films" },
  { label: "Photography", href: "#photography" },
  { label: "Moments", href: "#moments" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Enquire", href: "#enquire" },
];

export const HERO_VIDEO =
  "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/j3504fhs_Flyora%20Weddings%20highlights04.mov";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1555515597-a1f74be3beb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjBkYXJrJTIwd2VkZGluZyUyMGNvdXBsZSUyMHNpbGhvdWV0dGV8ZW58MHx8fHwxNzgzNTMwNTg1fDA&ixlib=rb-4.1.0&q=85";

export const PORTFOLIO = [
  {
    id: "aisha-rahil",
    couple: "Aisha & Rahil",
    location: "Kerala, India",
    country: "India",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1715285977649-4a83c0820399?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxrZXJhbGElMjBtdXNsaW0lMjB3ZWRkaW5nJTIwY291cGxlfGVufDB8fHx8MTc4MzUzMDU3NHww&ixlib=rb-4.1.0&q=85",
    span: "tall",
    vimeo_id: "1208188321",
  },
  {
    id: "fatima-zayan",
    couple: "Fatima & Zayan",
    location: "Dubai, UAE",
    country: "UAE",
    year: "2024",
    image:
      "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/zwgruahf_90909.webp",
    span: "wide",
    vimeo_id: "1208188324",
  },
  {
    id: "devika-arjun",
    couple: "Devika & Arjun",
    location: "Thrissur, India",
    country: "India",
    year: "2023",
    image:
      "https://images.unsplash.com/photo-1665960213508-48f07086d49c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxoaW5kdSUyMHdlZGRpbmclMjBjZXJlbW9ueSUyMGNvdXBsZSUyMGx1eHVyeXxlbnwwfHx8fDE3ODM1MzA1NzR8MA&ixlib=rb-4.1.0&q=85",
    span: "wide",
    vimeo_id: "1208188319",
  },
  {
    id: "priya-vikram",
    couple: "Priya & Vikram",
    location: "London, UK",
    country: "UK",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxoaW5kdSUyMHdlZGRpbmclMjBjZXJlbW9ueSUyMGNvdXBsZSUyMGx1eHVyeXxlbnwwfHx8fDE3ODM1MzA1NzR8MA&ixlib=rb-4.1.0&q=85",
    span: "tall",
    vimeo_id: "1208188320",
  },
  {
    id: "maria-thomas",
    couple: "Maria & Thomas",
    location: "Kochi, India",
    country: "India",
    year: "2023",
    image:
      "https://images.unsplash.com/photo-1524650448000-02d0a2aeb6cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxjaHJpc3RpYW4lMjB3ZWRkaW5nJTIwY2h1cmNoJTIwY291cGxlfGVufDB8fHx8MTc4MzUzMDU3NHww&ixlib=rb-4.1.0&q=85",
    span: "wide",
  },
  {
    id: "sarah-daniel",
    couple: "Sarah & Daniel",
    location: "Manchester, UK",
    country: "UK",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1551049699-b58eccc77864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxjaHJpc3RpYW4lMjB3ZWRkaW5nJTIwY2h1cmNoJTIwY291cGxlfGVufDB8fHx8MTc4MzUzMDU3NHww&ixlib=rb-4.1.0&q=85",
    span: "tall",
  },
  {
    id: "rida-zahid",
    couple: "Rida & Zahid",
    location: "Kerala, India",
    country: "India",
    year: "2025",
    image:
      "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/t4uxcfv1_0987.webp",
    span: "wide",
  },
  {
    id: "nadia-idris",
    couple: "Nadia & Idris",
    location: "Abu Dhabi, UAE",
    country: "UAE",
    year: "2025",
    image:
      "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/a07iat2q_123rewq.webp",
    span: "tall",
  },
];

export const REEL_MOMENTS = [
  {
    id: "first-look",
    duration: "00:04",
    image:
      "https://images.unsplash.com/photo-1610173827043-9db50e0d8ef9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxicmlkZSUyMGZpcnN0JTIwbG9vayUyMGNpbmVtYXRpYyUyMHdlZGRpbmd8ZW58MHx8fHwxNzgzNTMwNTg1fDA&ixlib=rb-4.1.0&q=85",
    caption:
      "This moment lasted 4 seconds. We made sure it lasts forever.",
    label: "The First Look",
  },
  {
    id: "father-hug",
    duration: "00:11",
    image:
      "https://images.unsplash.com/photo-1779055660386-c3ff4d90cfcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxlbW90aW9uYWwlMjBmYXRoZXIlMjBodWdnaW5nJTIwYnJpZGUlMjB3ZWRkaW5nfGVufDB8fHx8MTc4MzUzMDU4NXww&ixlib=rb-4.1.0&q=85",
    caption: "He said nothing. That's why we filmed it.",
    label: "Father & Daughter",
  },
  {
    id: "vows",
    duration: "00:19",
    image:
      "https://images.unsplash.com/photo-1558616536-b7305b258ada?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxncm9vbSUyMGNyeWluZyUyMHZvd3MlMjB3ZWRkaW5nfGVufDB8fHx8MTc4MzUzMDU4NXww&ixlib=rb-4.1.0&q=85",
    caption: "One moment. One promise. One film your children will watch.",
    label: "The Vows",
  },
  {
    id: "last-dance",
    duration: "00:47",
    image:
      "https://images.unsplash.com/photo-1639330693395-0944b5bef0c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHx3ZWRkaW5nJTIwcmVjZXB0aW9uJTIwbHV4dXJ5JTIwY2luZW1hdGljfGVufDB8fHx8MTc4MzUzMDU3NHww&ixlib=rb-4.1.0&q=85",
    caption: "The wedding ends at midnight. The story shouldn't.",
    label: "The Last Dance",
  },
];

export const MANIFESTO = [
  "We don't film weddings. We preserve moments people forget happened.",
  "The wedding ends at midnight. The story shouldn't.",
  "Some moments last seconds. We make them last generations.",
  "For every wedding film, we review thousands of frames to find the moments nobody planned.",
  "One day. Thousands of moments. One story worth keeping forever.",
];

export const PROOF_STATS = [
  { number: "17", suffix: "×", label: "Times the bride watched her film in week one" },
  { number: "6", suffix: "min", label: "The film your children will watch in 30 years" },
  { number: "2,000", suffix: "+", label: "Moments filmed so you don't miss the one that matters" },
  { number: "3·2·1", suffix: "", label: "Three cameras. Two filmmakers. One story." },
];

export const PHOTOGRAPHY = [
  {
    id: "hindu-bride-red",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/0hm7gto4_123erty.webp",
    caption: "The Bride, In Red",
    orientation: "portrait",
  },
  {
    id: "henna-palm",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/x9bfxpji_12345r.webp",
    caption: "His Name, On Her Palm",
    orientation: "portrait",
  },
  {
    id: "together-forever",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/emizap4f_34r5.webp",
    caption: "Together, Forever",
    orientation: "landscape",
  },
  {
    id: "arches",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/fhmlb8zv_903rf.webp",
    caption: "Under the Arches",
    orientation: "landscape",
  },
  {
    id: "aisle",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/5leit08j_12wdfr.webp",
    caption: "The Long Walk",
    orientation: "portrait",
  },
  {
    id: "hands",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/jzfeb5tn_12qa.webp",
    caption: "One Promise",
    orientation: "landscape",
  },
  {
    id: "south-bride-swing",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/c3ztmdds_123w.webp",
    caption: "Temple Gold",
    orientation: "portrait",
  },
  {
    id: "south-bride",
    src: "https://customer-assets.emergentagent.com/job_story-keeper-42/artifacts/8qmfs2te_12.webp",
    caption: "Heirloom Gold",
    orientation: "portrait",
  },
];

export const CONTACTS = [
  {
    territory: "India",
    country: "Kerala",
    phone: "+91 97471 17777",
    email: "hello@flyoraweddings.com",
  },
  {
    territory: "Dubai",
    country: "UAE",
    phone: "+91 97471 17777",
    email: "hello@flyoraweddings.com",
  },
  {
    territory: "London",
    country: "United Kingdom",
    phone: "+91 97471 17777",
    email: "hello@flyoraweddings.com",
  },
];
